import React from 'react';
import './Banner.css'

const Banner = () => {
    return (
        <>
          <div className="banner">
            <div>
               <h1 className="dream d-flex justify-content-center align-self-center">Dream League Scorer</h1> 
               <h1 className="team d-flex justify-content-center align-self-center">Make Your Own Team</h1>
              </div>
            </div>  
        </>
    );
};

export default Banner;